import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Header from './components/Header/index.jsx';
import Footer from './components/Footer/index.jsx';
import GalaShow from './components/GalaShow/index.jsx';
import Home from './components/Home/index.jsx';

// Performers
import EmilyPortrait from './assets/emily.jpg';
import TonyPortrait from './assets/tony.jpg';
import BexPortrait from './assets/bex.jpg';
import DominiquePortrait from './assets/dominique.jpg';
import KrystenPortrait from './assets/krysten.jpg';
import SamPortrait from './assets/sam.jpg';
import AustinPortrait from './assets/austin.jpg';
import KatherinePortrait from './assets/katherine.jpg';

import * as serviceWorker from './serviceWorker';
// import 'bootstrap/dist/scss/bootstrap.css';
import { HashRouter as Router, Route, Link, Switch } from "react-router-dom";


const appState = {
  performers: [
    {
      name: `Sam Malcolm`,
      bio: `<p>An international award winning performer, Sam Malcolm pairs jaw-dropping juggling proficiency with comedic cleverness to make each show he performs extraordinary.</p><p>In 2013, Sam took home his first gold medal from the International Jugglers’ Association Numbers Championship. He has since won several awards related to his juggling, including the Boulder Circus Arts Award, X Juggling Awards, and was a finalist at the 2016 IJA Stage Championships. The exciting and raw nature of Sam’s street show has also made him a hit with audiences and won him countless awards, such as the San Diego Busker’s Festival People’s Choice Award and Best Outdoor Show at the Edmonton International Fringe Theatre Festival.</p><p>Now living in Denver, Colarado, Sam is originally from the Stillwater Paiute-Shoshone Reservation. Growing up on the reservation, he experienced and witnessed the struggles of discrimination, racism, poverty, and substance abuse on his community. His passion for connecting through performance stems from his desire to alleviate the pain of these realities from those around him. Today, while focusing on performing the best show possible, Sam is vocal about educating youth, overcoming stereotypes and aims to be a positive role model with strong cultural values and principles. He also works to bring awareness to issues within Native communities by working within his community and with charitable organizations.</p>`,
      portrait: {
        src: SamPortrait,
        caption: `Photo credit: <a href="https://www.facebook.com/denverdancephotography/?__tn__=%2CdK%2AF-R&eid=ARBC4fXHkk04JRSOfEiB4TP4txgCPOogoMyWEUk5T7zYR6-E_7TVS3vz5Vz8I0_eb0FusyhoDubBZKYs">Eli Akerstein Photography</a>`
      },
    },

    {
      name: 'Tony Steinbach',
      bio: '',
      portrait: {
        src: TonyPortrait,
      },
    },
    {
      name: `Emily Moore`,
      bio: `<p>If you've seen Emily perform before, you'll know that flower sticks are a recent thing for her. Inspired by Sho Kasuya, the 2018 IJA Juniors' Champion, Emily has been working her way through a new chapter in her juggling, exploring what you can do (and should not do!) with this prop. This year at LCJF she is debuting her routine, "Dance of the Flower-sticks.”</p><p>Emily will also be teaching an “Intro to Flower Sticks” workshop during the day at the festival. So, if you want to learn more about this unique prop, attend her workshop or drop in to Wallace Hall after the show to chat!</p>`,
      portrait: {
        src: EmilyPortrait,
      },
    },
    {
      name: `Austin Smith`,
      bio: `<p>Austin is one of those rare second generation jugglers, having learned from his dad at the age of 7. Now, at 193cm tall with a wingspan of 198cm, heʼs hard to miss on Burlington, Vermontʼs iconic Church Street where he can usually be found busking. His juggling skills are spintastic, fliptastic and bounce-slappity-poppin’! In the past year, Austin has performed at 3 juggling festivals, entertained unsuspecting pedestrians and coached campers at Circus Smirkus.</p>`,
      portrait: {
        src: AustinPortrait,
      },
    },
    {
      name: `Dominique Rabideau`,
      bio: `<p>Dominique is a Montreal-based juggler who has been performing for over 10 years. Specializing in hat manipulation, Dominique’s high-energy performance style has been described as playful and musical, and she has juggled alongside bands such as Tera Melos, Floral, and Gulfer. This past year she was a special guest at the International Jugglers’ Association’s annual festival, performing in their Welcome Show! When she’s not juggling, you can find her creating macarons, cakes and other sweet treats in her secret dessert laboratory.</p>`,
      portrait: {
        src: DominiquePortrait,
      },
    },
    {
      name: `Krysten Hagedorn`,
      bio: `<p></p>`,
      portrait: {
        src: KrystenPortrait,
      },
    },
    {
      name: `Bex in Motion`,
      bio: `<p>Bex in Motion is a professional hula hoop entertainer with an acrobatic flair.  After finding hoop dance through an after school program in teachers’ college, Bex and her hoop have been inseparable. Inspired by her gymnastics and yoga background, Bex is a masterful performer in multi-hoop tricks, fire and LED entertainment. Her comedy and interaction with the audience will put a spring in your step and a smile to your face.</p><p>She has performed across Canada and internationally including New Zealand, Germany, India, and Switzerland. She dazzles crowds large and small and loves working with clients to create the ultimate shows, events and workshops. Young or young-at-heart, Bex puts on a show that is sure to move you!</p><p>Currently residing in Toronto, Bex is happy to travel for shows and events, please contact her at <a href="mailto:info@bexinmotion.com">info@bexinmotion.com</a> for more information regarding packages and rates.</p>`,
      portrait: {
        src: BexPortrait,
      },
    },
    {
      name: `Katherine Marino`,
      bio: `<p>Katherine Marino has been teaching and performing professionally for over 10 years. She holds degrees in both Dance and Environmental Studies from Hobart and William Smith Colleges where she was awarded multiple arts and academic honors. Upon graduating Summa Cum Laude in 2012, Katherine won a Fulbright fellowship to spend one year teaching and studying in Argentina. During her time abroad, she continued training in a wide array of movement styles and circus arts including contemporary dance, aerial silks, partner acrobatics, contact improvisation, and juggling. Upon returning to the United States, Katherine joined esteemed company PUSH Physical Theatre, where she combined her knowledge of contemporary dance with mime, circus, and theatrical storytelling. She has presented original dance-theatre work in the Rochester Fringe Festival and the International Shanghai Drama Festival, among others. Throughout her career Katherine has performed nationally and internationally including in South America, Europe, Asia, and all across the USA. She is thrilled to be delving into a career working full-time as an independent multi-disciplinary artist; she is eager to continue pushing boundaries of dance, circus, and physical theatre to create celebratory and memorable experiences.</p>`,
      portrait: {
        src: KatherinePortrait,
      },
    },

  ],
  games: [
    'Simon Says: Juggle!',
    '5-object endurance',
    '7-object endurance',
    'Balance competition (club, ring, or hoop)',
    'Most diabolos for longest time',
    '7-Club Passing Endurance',
    'Distance Self-Toss (any prop out of a cascade)',
    'Snack Toss (No juggling experience necessary!)',
    'Quarter Juggling',
    'Blind Juggling',
    'Juggling Club Combat (Two initial rounds. Top 3 from each round move on to semi-finals. Top 2 face-off for the title.)',
  ],
  schedule: [
    {
      day: 'Friday, October 25',
      events: [
        { time: '6pm - 10pm', event: 'Open juggling and workshops in the Main Gym' },
        { time: '11pm - 2am', event: 'Renegade Variety Show (ages 19+) at The Mansion!' },
      ]
    },
    {
      day: 'Saturday, October 26',
      events: [
        { time: '10am – 6pm', event: 'Open juggling and workshops in the main gym' },
        { time: '3pm - 3:45pm', event: 'Juggling Games in the Main Gym' },
        { time: '7:30pm - 9pm', event: 'Gala show! (link in the menu)' },
        { time: '9pm - midnight', event: 'Open juggling in the main gym' },
      ]
    },
    {
      day: 'Sunday, October 27',
      events: [
        { time: '10am – 5pm', event: 'Open juggling and workshops in the main gym' },
      ]
    },
  ],
  faqs: [
    {
      question: 'What is a juggling festival?',
      answer: 'A juggling festival is a weekend-long event featuring an open juggling space where jugglers and non-jugglers alike can learn, train, and talk shop about juggling. There are usually workshops where experienced jugglers can share their skills with others who want to learn, a Saturday night show where performers wow you with their skills, and organized juggling games and competitions with prizes for the winners. Our festival will have all of these things and more! This year on Friday night we are adding a 19+ juggling show where anything goes!',
    },
    {
      question: 'Who can attend the festival?',
      answer: 'The short answer? Anyone and everyone! Some aspects of the festival are geared to absolute beginners, like our learn to juggle lessons. Other aspects of the festival are geared to absolute experts, like our 5-ball juggling endurance competition. Even if you have no desire to juggle or learn juggling, you are welcome to join us in the Main Gym and at the Gala Show to watch advanced jugglers train and perform their phenomenal skills. Some of the jugglers at this event are able to juggle 7 fire torches, others are able to spin 6 hula hoops on their body. There will be a mind-blowing amount of talent at this festival - drop by even if it’s just to watch!',
    },
    {
      question: 'I don’t have juggling props, can I borrow some?',
      answer: 'Yes! The Queen’s Juggling Clubs has spare balls, rings, clubs, flower sticks, and diabolos for you to borrow and use on site. There will also be vendors selling juggling props that you can take home with you to keep learning and practicing with! If you are enjoying juggling, you can also attend our weekly club meetings year-round where we rent out props. We meet Wednesday nights and Saturday afternoons - details can be found on our website at <a href="http://kingstonjugglers.club">kingstonjugglers.club</a>',
    },
    {
      question: 'How can I get involved with the festival or local juggling club?',
      answer: 'We are always looking for more jugglers in the area to hang out with! You can join our mailing list to receive updates on meeting times and locations here: <a href="https://tinyletter.com/kingstonjugglers">https://tinyletter.com/kingstonjugglers</a>',
    },
    {
      question: 'What can I expect in the juggling gym?',
      answer: 'The juggling gym is a community-oriented space for people to practice juggling, flow arts, and other, similar circus and object manipulation skills. In the past we have had cardistry, hacky sack, and unicycle break out circles as well. You are welcome to watch or join in the fun! We also have a front desk area with friendly volunteers who can tell you about what’s happening or introduce you to someone who can show you around!',
    },
  ],
  accomodations: [
    { category: 'B&Bs', locations: [
      { name: 'Rosemount Inn', website: 'https://www.rosemountinn.com/rooms' },
      { name: 'Hochelega Inn', website: 'https://thehochelagainn.com/rooms-and-suites/' },
    ] },
    { category: 'Hotels', locations: [
      { name: 'Delta', website: 'https://www.marriott.com/hotels/travel/ygkdk-delta-hotels-kingston-waterfront/' },
      { name: 'Confederation Place', website: 'https://www.confederationplace.com/' },
      { name: 'Four Points by Sheraton', website: 'https://www.marriott.com/hotels/travel/ygkfp-four-points-kingston/' },
      { name: 'Holiday Inn Waterfront', website: 'http://www.hikingstonwaterfront.com/' },
      { name: 'Best Western', website: 'https://www.bestwesternkingston.ca/' },
      { name: 'Econo Lodge City Centre', website: 'https://www.choicehotels.com/ontario/kingston/econo-lodge-hotels/cn792' },
    ] },
  ]
}

function AppRouter() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path="/" exact render={routeProps => <Home {...appState} />} />
        <Route path="/GalaShow" render={routeProps => <GalaShow {...appState} />} />
      </Switch>
      <Footer />
    </Router>
  );
}

ReactDOM.render(<AppRouter />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
